import React from 'react'
import { I18nextProvider } from 'react-i18next'
import i18n from '../../i18n'

const AppI18nProvider = ({ children }) => (
	<I18nextProvider i18n={i18n}>
		{children}
	</I18nextProvider>
)

AppI18nProvider.displayName = 'AppI18nProvider'
export default AppI18nProvider
